export const BID = 'BID';
export const BID_PENDING = 'BID_PENDING';
export const BID_SUCCESSFUL = 'BID_SUCCESSFUL';
export const ZIP_CODE = 'ZIP_CODE';
export const LOADING = 'LOADING';

export type BidModalType =
    | typeof BID
    | typeof BID_PENDING
    | typeof BID_SUCCESSFUL
    | typeof LOADING
    | typeof ZIP_CODE;
